import { TransactionListResponseDto, TransactionResponseDto } from 'app/API/models';

const RECENT_TRANSACTIONS_LIMIT = 5;

export const selectRecentTransactions = (
  response: TransactionListResponseDto | TransactionResponseDto[],
): TransactionResponseDto[] => {
  const transactions = Array.isArray(response) ? response : response?.transactions ?? [];
  return [...transactions]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .slice(0, RECENT_TRANSACTIONS_LIMIT);
};
